import React from "react";
import styles from "./AberrationManagement.module.css";

const AberrationManagement = () => {
  return (
    <div id="main-container">
      <div className="container">
        <h2 className="mb-4 userLevel-Title">Aberration Management</h2>
        <div className={`${styles.arrow} mb-4`}>
          <img src="/assets/images/ArrowLeft.png" alt="" />
          <span className="">Quality and Symptom Management</span>
        </div>

        {/** SYMPTOM FILTER */}
        <div className="mb-4">
          <div className="row mb-3">
            <div className="col-12 col-md-7">
              <div className="row">
                <div className="col-12 mb-2 mb-md-0 col-md-auto">
                  <div className={styles.topLabelSymptom}>
                    <span>Aberration</span>
                  </div>
                </div>

                <div className={`${styles.topLabelVal} col`}>
                  <select
                    name="severity"
                    className={`form-select w-full ${styles.dropdownColor}`}
                    id="severity"
                  >
                    <option value="Minor">2. Reduced Performance</option>
                    <option value="Major">Major</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12 col-md-7">
              <div className="row">
                <div className="col-12 mb-2 mb-md-0 col-md-auto">
                  <div className={styles.topLabelSymptom}>
                    <span>Record ID</span>
                  </div>
                </div>

                <div className={`${styles.topLabelVal} col`}>4</div>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12 ">
              <div className="row">
                <div className="col-12 mb-2 mb-md-0 col-md-auto">
                  <div className={styles.topLabelSymptom}>
                    <span>Aberration Name *</span>
                  </div>
                </div>
                <div className={`${styles.topLabelVal} col`}>
                  <input type="text" className="form-control" />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12 ">
              <div className="row">
                <div className="col-12 mb-2 mb-md-0 col-md-auto">
                  <div className={styles.topLabelSymptom}>
                    <span>Aberration Description</span>
                  </div>
                </div>
                <div className={`${styles.topLabelVal} col`}>
                  <textarea
                    className={`${styles.userdescinput} form-control`}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12 ">
              <div className="row">
                <div className="col-12 mb-2 mb-md-0 col-md-auto">
                  <div className={styles.topLabelSymptom}>
                    <span>Guidance *</span>
                  </div>
                </div>
                <div className={`${styles.topLabelVal}  col`}>
                  <textarea
                    className={`${styles.userdescinput}  form-control`}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12 col-md-7">
              <div className="row">
                <div className="col-12 mb-2 mb-md-0 col-md-auto">
                  <div className={styles.topLabelSymptom}>
                    <span>Restricted To</span>
                  </div>
                </div>
                <div className={`${styles.topLabelVal} col`}>
                  <select
                    name="severity"
                    className={`form-select w-full ${styles.dropdownColor} ${styles.input}`}
                    id="severity"
                  >
                    <option value="Minor">Product</option>
                    <option value="Major">Major</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12 col-md-7">
              <div className="row">
                <div className="col-12 mb-2 mb-md-0 col-md-auto">
                  <div className={styles.topLabelSymptom}>
                    <span>
                      Professional Check{" "}
                      <span className={`${styles.topLabelVal} `}>(i)</span>
                    </span>
                  </div>
                </div>
                <div className={`${styles.topLabelVal} col`}>
                  <select
                    name="severity"
                    className={`form-select w-full ${styles.dropdownColor}`}
                    id="severity"
                  >
                    <option value="Minor">No</option>
                    <option value="Major">Major</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12 col-md-7">
              <div className="row">
                <div className="col-12 mb-2 mb-md-0 col-md-auto">
                  <div className={styles.topLabelSymptom}>
                    <span>Updated By</span>
                  </div>
                </div>

                <div className={`${styles.topLabelVal} col`}>11823499</div>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12 col-md-7">
              <div className="row">
                <div className="col-12 mb-2 mb-md-0 col-md-auto">
                  <div className={styles.topLabelSymptom}>
                    <span>Updated At</span>
                  </div>
                </div>

                <div className={`${styles.topLabelVal} col`}>
                  14/2/2023 18:49
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12 col-md-7">
              <div className="row">
                <div className="col-12 mb-2 mb-md-0 col-md-auto">
                  <div className={styles.topLabelSymptom}>
                    <span>Created By</span>
                  </div>
                </div>

                <div className={`${styles.topLabelVal} col`}>22823499</div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${styles.actions} d-flex flex-row`}>
          <button className={styles.requestassistance}>Edit</button>
          <button className={styles.reportbtn}>Create New</button>
          <button className={styles.btn}>Submit</button>
          <button className={styles.cancel}>Delete</button>
        </div>
      </div>
    </div>
  );
};

export default AberrationManagement;
